export interface AppConfig {
  apiUrl: string;
  cognitoDomain: string;
  clientId: string;
  redirectUri: string;
}

let cachedConfig: AppConfig | null = null;

export async function getConfig(): Promise<AppConfig> {
  if (cachedConfig) return cachedConfig;
  const resp = await fetch('/config.json');
  const json = await resp.json();
  cachedConfig = {
    apiUrl: json.apiUrl,
    cognitoDomain: json.cognitoDomain,
    clientId: json.clientId,
    redirectUri: window.location.origin + '/',
  };
  return cachedConfig;
}
